import { ConfigProps } from '@config/types'

const config = ({ deploymentEnv, authUrl, ssoDomain }: ConfigProps) => ({
  authURL: authUrl,
  accountPath: '/profile',
  domain: ssoDomain,
  audience: 'https://api.onelog.ch/profile/v1',
  scope: 'openid email fields admeira:id offline_access',
  ssoSourceSuffix: 'Blick-DE',
  ssoSourceSuffix___romandie: 'Blick-FR',
  loginCookie: 'loginRedirect',
  logoutCookie: 'logoutRedirect',
  loginPath: '/login',
  logoutPath: '/logout',
  metadataPath: '/metadata',
  heartbeatPath: '/heartbeat',
  responseType: 'code',
  state: 'blickch',
  state___romandie: 'blickromandiech',
  cookieDomain: 'blick.ch',
  clientID:
    deploymentEnv === 'prod'
      ? 'iq6JnMWfrXwdLWQxNSPzlCChFaMI2O9B'
      : 'QiQsPyS8NNexn6BGbIdfVAyGaihbDsrP',
  lang: 'de',
  lang___romandie: 'fr',
})

export type configType = ReturnType<typeof config>
export default config
